

// import React, { useState } from 'react';
// import './Dashboard.css';
// import NewPatientRegistration from './NewPatientRegistration';
// // import DashboardOverview from './DashboardOverview';

// const Dashboard = () => {
//   const [activeModule, setActiveModule] = useState('Dashboard');
//   const [activeSubModule, setActiveSubModule] = useState('');
//   const [openModule, setOpenModule] = useState(null);
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // NEW

// const [mobileSidebar, setMobileSidebar] = useState(false);



//   const user = JSON.parse(localStorage.getItem("user"));
// const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

//   const groupedPermissions = {};

// permissions.forEach(p => {

//   if (!groupedPermissions[p.screen_type]) {
//     groupedPermissions[p.screen_type] = [];
//   }

//   groupedPermissions[p.screen_type].push(p);

// });

// //   const modules = [
// //         { id: 0, name: 'Dashboard', icon: '⊞' },
// //   { 
// //     id: 1, name: 'Patient Registration', icon: '👤', 
// //     subModules: ['New Registration', 'Patient History', 'Emergency Reg'] 
// //   },
// //   { 
// //     id: 2, name: 'Appointment Scheduling', icon: '📅', 
// //     subModules: ['Book Appointment', 'Doctor Schedules', 'Queue Management'] 
// //   },
// //   { 
// //     id: 3, name: 'Medical Records (EMR)', icon: '📄', 
// //     subModules: ['Diagnosis Records', 'Treatment History', 'Medical History'] 
// //   },
// //   { 
// //     id: 4, name: 'Billing & Payment', icon: '💳', 
// //     subModules: ['Patient Billing', 'Insurance Processing', 'Financial Reports'] 
// //   },
// //   { 
// //     id: 5, name: 'Laboratory Management', icon: '🧪', 
// //     subModules: ['Test Requests', 'Sample Tracking', 'Lab Reports'] 
// //   },
// //   { 
// //     id: 6, name: 'Pharmacy Management', icon: '💊', 
// //     subModules: ['Drug Inventory', 'Prescriptions', 'Supplier Management'] 
// //   },
// //   { 
// //     id: 7, name: 'Inpatient & Ward', icon: '🛌', 
// //     subModules: ['Bed Allocation', 'Admission/Discharge', 'Nursing Notes'] 
// //   },
// //   { 
// //     id: 8, name: 'Inventory & Assets', icon: '📦', 
// //     subModules: ['Equipment Tracking', 'Stock Monitoring', 'Maintenance'] 
// //   },
// //   { 
// //     id: 9, name: 'Staff & HR Management', icon: '👥', 
// //     subModules: ['Staff Records', 'Duty Schedules', 'Payroll/Leave'] 
// //   },
// //   { 
// //     id: 10, name: 'User Settings', icon: '⚙️', 
  
// //   }
// // ];

// const screenComponents = {
//   "Patient Registration": NewPatientRegistration,

// };


// const ScreenComponent = screenComponents[activeSubModule];


//   return (
//     <div className="dashboard-container">

//       {/* SIDEBAR */}
//      <aside className={`sidebar 
//   ${sidebarCollapsed ? 'collapsed' : ''} 
//   ${mobileSidebar ? 'mobile-open' : ''}`}>

 

//          <div className="sidebar-brand">
//               <div className="close-btn" onClick={() => setMobileSidebar(false)}>✕</div>
//   {sidebarCollapsed ? (
//     <span className="logo-icon">eM</span>
//   ) : (
//     <img
//       src="https://buildfastvapi.emedha.in/images/image-1733140504527.png"
//       alt="eMedha"
//       className="logo-img"
//     />
//   )}
// </div>


// <nav className="nav-menu">

//   {Object.keys(groupedPermissions).map(type => (

//     <div key={type} className="nav-item-wrapper">

//       <div
//         className={`nav-link ${openModule === type ? "active" : ""}`}
//         onClick={() =>
//           setOpenModule(openModule === type ? null : type)
//         }
//       >
//         <div className="link-content">
//           <span className="icon">
//             {type === "MASTER" ? "📂" :
//              type === "TRANSACTION" ? "🧾" :
//              "📊"}
//           </span>

//           {!sidebarCollapsed && (
//             <span className="text">
//               {type}
//             </span>
//           )}
//         </div>

//         {!sidebarCollapsed && (
//           <span className={`chevron ${openModule === type ? 'rotate' : ''}`}>
//             ⌵
//           </span>
//         )}

//       </div>

//       {/* SCREENS */}
//       {!sidebarCollapsed && openModule === type && (

//         <div className="sub-menu-container">

//           {groupedPermissions[type].map(screen => (

//             <div
//               key={screen.screen_id}
//               className={`sub-nav-link ${
//                 activeSubModule === screen.screen_name
//                   ? "sub-active"
//                   : ""
//               }`}
//               onClick={() => setActiveSubModule(screen.screen_name)}
//             >
//               {screen.screen_name}
//             </div>

//           ))}

//         </div>

//       )}

//     </div>

//   ))}

// </nav>
//       </aside>

// {mobileSidebar && (
//   <div
//     className="sidebar-overlay"
//     onClick={() => setMobileSidebar(false)}
//   ></div>
// )}
//       {/* MAIN AREA */}
//       <div className="main-wrapper">

//         <header className="main-header">

//           <div className="header-left">

//             {/* HAMBURGER BUTTON */}
//            <div
//   className="hamburger"
//   onClick={() => {
//     if (window.innerWidth < 992) {
//       setMobileSidebar(true);
//     } else {
//       setSidebarCollapsed(!sidebarCollapsed);
//     }
//   }}
// >
//   ☰
// </div>

//             <div className="search-box">
//               <span>🔍</span>
//               <input type="text" placeholder="Search for Patients, Doctors..." />
//             </div>

//           </div>

//  <div className="header-right">

// <div className="admin-pill">

// <img
// src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
// width="30"
// />

// <span>{user?.name}</span>

// <button
// onClick={()=>{
// localStorage.clear();
// window.location.href="/";
// }}
// >
// Logout
// </button>

// </div>

// </div>
//         </header>

//         {/* <main className="content-area">
//           {activeModule === 'Dashboard' ? (
//             <>
//               <h2>Hospital Overview</h2>
//               <DashboardOverview />
//             </>
//           ) : (
//             <>
//               {activeSubModule === 'New Registration'
//                 ? <NewPatientRegistration />
//                 : <h2>{activeSubModule || activeModule}</h2>}
//             </>
//           )}
//         </main> */}
//           <main className="content-area">
// <main className="content-area">

//   {!activeSubModule ? (
//     <>
//       <h2>Hospital Dashboard</h2>
//       <div className="dashboard-welcome">
//         <p>Welcome to the Hospital Management System.</p>
//         <p>Select a module from the sidebar to get started.</p>
//       </div>
//     </>
//   ) : ScreenComponent ? (
//     <ScreenComponent setActiveSubModule={setActiveSubModule} />
//   ) : (
//     <h2>{activeSubModule}</h2>
//   )}

// </main>
// </main>

//       </div>
//     </div>
//   );
// };

// export default Dashboard;

// import DashboardOverview from './DashboardOverview';



import React, { useState } from 'react';
import './Dashboard.css';
import NewPatientRegistration from './NewPatientRegistration';
import AppointmentRegistration from './AppointmentRegistration'
import PostAppointment from './PostAppointment'
import LabTestRequest from './LabTestRequest'
import LabTestStatus from './LabTestStatus'
import AssetMaster from './AssetMaster'
import ItemMaster from './ItemMaster'
import Indent from './Indent'
import DepartmentMaster from './DepartmentMaster'
import PurchaseOrder from './PurchaseOrder'
import SupplierMaster from './SupplierMaster'
import DoctorMaster from './DoctorMaster'
import StaffMaster from './StaffMaster'
import BedsMaster from './BedsMaster'
import ProceduresMaster from './ProceduresMaster'
import InpatientManagement from './InpatientManagement'
import DischargeDetails from './DischargeDetails'
import PatientDashboard from './PatientDashboard'
import StaffRoster from './StaffRoster';
import MatirialReceipt from './MaterialReceipt';
import MatirialRequest from './MatirialRequest';
import MatirialIssues from './MatirialIssues';
import DoctorRoster from './DoctorRoster';
import LabTestRateCard from './LabTestRateCard';
import Medicines from './Medicines';
import PurchaseOrderMedicines from './PurchaseOrderMedicines';
import StockEntryMRN from './StockEntryMRN';
import StockTransfer from './StockTransfer';
import InternalConsumption from './InternalConsumption';
import PharmaBillingB2C from './PharmaBillingB2C';
import Locations from './Locations';
import PurchaseIndent from './PurchaseIndent';
import MedicineDashboard from './MedicineDashboard';
import PoApprovalsMaster from './PoApprovalsMaster';
import LabTestCategoryMaster from './LabTestCategoryMaster';
import LabTestsMaster from './LabTestsMaster';
import InsuranceMaster from './InsuranceMaster';
import VitalTypeMaster from './VitalTypeMaster';
import IpdVitalsReadings from './IpdVitalsReadings';
import IpdDoctorVisits from './IpdDoctorVisits';
import IpdLabDiagnostics from './IpdLabDiagnostics';
import IpdProcedures from './IpdProcedures';
import InPatientDashboard from './InPatientDashboard';
import IndentReport from '../Reports/IndentReport';
import POReport from '../Reports/POReport';
import MRNReport from '../Reports/MRNReport';
import StockIssueReport from '../Reports/StockIssueReport';
import ConsumptionReport from '../Reports/ConsumptionReport';

const Dashboard = () => {
  const [activeModule, setActiveModule] = useState('Dashboard');
  const [activeSubModule, setActiveSubModule] = useState('');
  const [openModule, setOpenModule] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // NEW
const [screenAction, setScreenAction] = useState(null);
const [mobileSidebar, setMobileSidebar] = useState(false);
const [showProfileMenu, setShowProfileMenu] = useState(false);
const [openScreen, setOpenScreen] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

//   const groupedPermissions = {};

// permissions.forEach(p => {

//   if (!groupedPermissions[p.screen_type]) {
//     groupedPermissions[p.screen_type] = [];
//   }

//   groupedPermissions[p.screen_type].push(p);

// });


const groupedPermissions = {};

permissions.forEach(p => {

  if (!groupedPermissions[p.module_name]) {
    groupedPermissions[p.module_name] = {};
  }

  if (!groupedPermissions[p.module_name][p.screen_type]) {
    groupedPermissions[p.module_name][p.screen_type] = [];
  }

  groupedPermissions[p.module_name][p.screen_type].push(p);

});

// const handleScreenAction = (action) => {

//   if(action === "exit"){
//      setOpenScreen(null);
//      return;
//   }

//   setScreenAction(action);
// };

const [triggerSave, setTriggerSave] = useState(0);

const handleScreenAction = (action) => {
  console.log("ACTION CLICKED:", action);

  if(action === "exit"){
    setOpenScreen(null);
    setScreenAction(null); 
    return;
  }

  // If it's save, increment the trigger
  if(action === "save"){
    setTriggerSave(prev => prev + 1);
  }

  // Set the action so the child knows if it should enable/disable fields
  setScreenAction(action);
  
  // DON'T null it immediately. 
  // Let the child component handle it. 
  // You can reset it inside the child component if needed.
};

const screenComponents = {
  "Online Registration": NewPatientRegistration,
  "Appointment":AppointmentRegistration,
  "Post Appointment":PostAppointment,
  "Lab Test Request": LabTestRequest,
  "Lab Test Status (Sample Collection)":LabTestStatus,
  "Asset Master": AssetMaster,
  "Item Master":ItemMaster,
  "Supplier Master":SupplierMaster,
  "Purchase Indent": Indent,
  "Departments":DepartmentMaster,
  "Purchase Order":PurchaseOrder,
  "Doctors":DoctorMaster,
  "Staff":StaffMaster,
  "Beds":BedsMaster,
  "Procedures (Operations)":ProceduresMaster,
  "Inpatient & Ward Management":InpatientManagement,
  "Discharge Details":DischargeDetails,
  "Patient Dashboard":PatientDashboard,
  "Shift Roaster":StaffRoster,
  "Material Receipt":MatirialReceipt,
  "Material Request" : MatirialRequest,
  "Material Issues":MatirialIssues,
  "Doctor Roster":DoctorRoster,
  "Lab Test Rate Card":LabTestRateCard,
  "Medicines":Medicines,
  "Purchase Order Medicines":PurchaseOrderMedicines,
  "Stock Entry":StockEntryMRN,
  "Stock Transfer (Multiple Locations)":StockTransfer,
  "Internal Consumptions":InternalConsumption,
  "Billing (B2C)":PharmaBillingB2C,
  "Locations":Locations,
  "Purchase Indent Medicines":PurchaseIndent,
  "Medicine Dashboard":MedicineDashboard,
  "Approvals":PoApprovalsMaster,
  "Test Category Master":LabTestCategoryMaster,
  "Test Master":LabTestsMaster,
  "Insurance Master":InsuranceMaster,
  "Vital Type Master":VitalTypeMaster,
  "Vitals & Readings":IpdVitalsReadings,
  "Doctor Visits":IpdDoctorVisits,
  "Lab & Diagnostics":IpdLabDiagnostics,
  "Procedure/Surgeries":IpdProcedures,
  "Active Inpatient Dashboard":InPatientDashboard,
  "Indent Report":IndentReport,
  "PO Report":POReport,
  "MRN Report":MRNReport,
  "Stock Transfer Report":StockIssueReport,
  "Consumption Report":ConsumptionReport,
};

const ScreenComponent = screenComponents[openScreen];


  return (
    <>
    {openScreen ? (

  <div className="screen-layout">

    <div className="screen-topbar">

     <div className="screen-left">
    <img
      src="https://buildfastvapi.emedha.in/images/image-1733140504527.png"
      className="screen-logo"
    />

 {/* <div className="screen-user">
  Welcome to <span className="screen-highlight">{openScreen}</span>,   <span className="user-icon">👤</span> {user?.name} 👋
</div> */}
 <div className="screen-user">
  Welcome to: <span className="user-icon">👤</span> {user?.name} 👋
</div>
  </div>
      
<div className="screen-title">
  {openScreen}
</div>

  {/* RIGHT ACTION BUTTONS */}
  <div className="screen-right">

<div className="screen-actions">

{
openScreen !== "Patient Dashboard" && openScreen !== "Active Inpatient Dashboard" && openScreen !== "Indent Report" && openScreen !== "PO Report" &&
openScreen !== "MRN Report" && openScreen !== "Stock Transfer Report" && openScreen !== "Consumption Report" &&(
permissions
  .filter(p => p.screen_name === openScreen)
  .map(p => (

  <>

  {p.can_add === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("add")}>➕</button>
  )}

  {p.can_edit === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("edit")}>✏️</button>
  )}

  {p.can_view === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("view")}>👁</button>
  )}

  {p.can_refresh === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("refresh")}>🔄</button>
  )}

  {p.can_save === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("save")}>💾</button>
  )}

  {p.can_approve === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("approve")}>✅</button>
  )}

  {p.can_print === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("print")}>🖨</button>
  )}

  {/* {p.can_exit === 1 && (
    <button className="icon-btn" onClick={()=>handleScreenAction("exit")}>❌</button>
  )} */}

  </>
)))}
<button className="icon-btn" onClick={()=>handleScreenAction("exit")}>❌</button>

</div>
 </div>
    </div>

    <div className="screen-body">

     {ScreenComponent && (
  <ScreenComponent
    screenAction={screenAction}
    setScreenAction={setScreenAction}
    triggerSave={triggerSave}
  />
)}

    </div>

  </div>

) : (



  <div className="dashboard-container">

      {/* SIDEBAR */}
     <aside className={`sidebar 
  ${sidebarCollapsed ? 'collapsed' : ''} 
  ${mobileSidebar ? 'mobile-open' : ''}`}>

 

         <div className="sidebar-brand">
              <div className="close-btn" onClick={() => setMobileSidebar(false)}>✕</div>
  {sidebarCollapsed ? (
    <span className="logo-icon">eM</span>
  ) : (
    <img
      src="https://buildfastvapi.emedha.in/images/image-1733140504527.png"
      alt="eMedha"
      className="logo-img"
    />
  )}
</div>


<nav className="nav-menu">

{Object.keys(groupedPermissions).map(module => (

<div key={module} className="nav-item-wrapper">

<div
className="nav-link"
onClick={()=>setOpenModule(openModule===module?null:module)}
>

<span className="icon">📁</span>

{!sidebarCollapsed && (
<span className="text">{module}</span>
)}

</div>


{/* SCREEN TYPES */}

{!sidebarCollapsed && openModule === module && (

<div className="sub-menu-container">

{Object.keys(groupedPermissions[module]).map(type => (

<div key={type}>

<div className="sub-module-title">

{type === "MODULE" ? "" :
type === "MASTER" ? "Masters" :
 type === "TRANSACTION" ? "Transactions" :
 "Reports"}

</div>


{groupedPermissions[module][type].map(screen => (

<div
key={screen.screen_id}
className="sub-nav-link"
onClick={()=>setOpenScreen(screen.screen_name)}
>

{screen.screen_name}

</div>

))}

</div>

))}

</div>

)}

</div>

))}

</nav>
      </aside>

{mobileSidebar && (
  <div
    className="sidebar-overlay"
    onClick={() => setMobileSidebar(false)}
  ></div>
)}
      {/* MAIN AREA */}
      <div className="main-wrapper">

        <header className="main-header">

          <div className="header-left">

            {/* HAMBURGER BUTTON */}
           <div
  className="hamburger"
  onClick={() => {
    if (window.innerWidth < 992) {
      setMobileSidebar(true);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  }}
>
  ☰
</div>

            <div className="search-box">
              <span>🔍</span>
              <input type="text" placeholder="Search for Patients, Doctors..." />
            </div>

          </div>

 <div className="header-right">

<div className="admin-pill" onClick={()=>setShowProfileMenu(!showProfileMenu)}>

<img
src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
width="30"
/>

<span>{user?.name}</span>

<div className="dropdown-arrow">▼</div>

{showProfileMenu && (

<div className="profile-dropdown">

<button>My Profile</button>

<button>Change Password</button>

<button
onClick={()=>{
localStorage.clear();
window.location.href="/";
}}
>
Logout
</button>

</div>

)}
</div>

</div>
        </header>

        {/* <main className="content-area">
          {activeModule === 'Dashboard' ? (
            <>
              <h2>Hospital Overview</h2>
              <DashboardOverview />
            </>
          ) : (
            <>
              {activeSubModule === 'New Registration'
                ? <NewPatientRegistration />
                : <h2>{activeSubModule || activeModule}</h2>}
            </>
          )}
        </main> */}
          <main className="content-area">
<main className="content-area">

  {!activeSubModule ? (
    <>
      <h2>Hospital Dashboard</h2>
      <div className="dashboard-welcome">
        <p>Welcome to the Hospital Management System.</p>
        <p>Select a module from the sidebar to get started.</p>
      </div>
    </>
  ) : ScreenComponent ? (
    <ScreenComponent setActiveSubModule={setActiveSubModule} />
  ) : (
    <h2>{activeSubModule}</h2>
  )}

</main>
</main>

      </div>
    </div>

)
  
}
  </>
  
  )
}

export default Dashboard;